import EmailPinAuth from './EmailPinAuth';

export default EmailPinAuth;
